export function swNumber(sharedModule) {
  /**
   * Directive to be used with ng-model; formats & parse numbers according to the
   * $locale settings. It's supposed to use in the money context & therefor it's
   * always showing 2 decimal places.
   *
   * Attributes:
   * * min - invalidates the field if provided value below the limit
   * * max - top limit
   * * min-default - same as 'min="-<defaul-limit>"'
   * * max-default - same as 'min="<defaul-limit>"'
   *
   * Note! min & max have lower priority then '*-default' - if both specified, the
   * default one will be used.
   */
  sharedModule.directive(
    'swNumber',
    ($locale: ng.ILocaleService, $parse: ng.IParseService, numberFilter) => {
      const DEFAULT_LIMIT = 99999999;

      return {
        restrict: 'A',
        require: '?ngModel',
        link: function postLink(scope, element, attrs, ctrl) {
          if (!ctrl) {
            // we lack ng-model
            return;
          }

          let min, minGetter, max, maxGetter;

          function format(value, rounding) {
            const number = numberFilter(value, rounding);

            if (!angular.isString(number)) {
              return;
            }

            // hack to avoid created RegExp objects for global string.replace
            return number.split($locale.NUMBER_FORMATS.GROUP_SEP).join('');
          }

          // TODO POS-673 cover rounding to 0 in tests
          const rounding = angular.isDefined(attrs.swInteger) ? 0 : 2;

          if (attrs.min && !isNaN(Number(attrs.min))) {
            min = () => Number(attrs.min);
          } else if (angular.isDefined(attrs.minDefault)) {
            min = () => -DEFAULT_LIMIT;
          } else {
            minGetter = $parse(attrs.min);
            min = () => {
              const parsed = minGetter(scope);
              if (angular.isNumber(parsed)) {
                return parsed;
              }

              return Number.NEGATIVE_INFINITY;
            };
          }

          if (attrs.max && !isNaN(Number(attrs.max))) {
            max = () => Number(attrs.max);
          } else if (angular.isDefined(attrs.maxDefault)) {
            max = () => DEFAULT_LIMIT;
          } else {
            maxGetter = $parse(attrs.max);
            max = () => {
              const parsed = maxGetter(scope);

              if (angular.isNumber(parsed)) {
                return parsed;
              }

              return Number.POSITIVE_INFINITY;
            };
          }

          function validate(value) {
            if (value < min()) {
              ctrl.$setValidity('min', false);
            } else {
              ctrl.$setValidity('min', true);
            }

            if (value > max()) {
              ctrl.$setValidity('max', false);
            } else {
              ctrl.$setValidity('max', true);
            }
          }

          // TODO consider cleaning model value when it's not valid

          ctrl.$formatters.unshift((modelValue) => {
            validate(modelValue);

            return format(modelValue, rounding);
          });

          ctrl.$parsers.unshift((viewValue) => {
            // to avoid error throwing while with ng1.0.6
            if (!angular.isString(viewValue)) {
              return;
            }

            // drop the group separators
            let value: any = viewValue.replace(
              $locale.NUMBER_FORMATS.DECIMAL_SEP,
              '.',
            );
            value = parseFloat(value);

            validate(value);

            return value;
          });

          element.on('blur', () => {
            ctrl.$setViewValue(format(ctrl.$modelValue, rounding));
            ctrl.$render();
          });
        },
      };
    },
  );
}
